import React from 'react'
import PropTypes from 'prop-types'
import { Form, Radio } from 'antd'
import css from '../../common/Form.css'

const PmsSelector = ({ onChange, value }) => (
  <Form.Item
    label="Select Practice Management System"
    className={css.itemLabel}
  >
    <Radio.Group
      name="pms"
      onChange={onChange}
      value={value}
      className={css.label}
    >
      <Radio.Button value="topsOrtho">topsOrtho</Radio.Button>
      <Radio.Button value="Dolphin">Dolphin</Radio.Button>
      <Radio.Button value="Cloud9">Cloud9</Radio.Button>
      <Radio.Button value="OrthoTracV2">OrthoTracV2</Radio.Button>
      <Radio.Button value="OpenDental">OpenDental</Radio.Button>
      <Radio.Button value={null}>None</Radio.Button>
    </Radio.Group>
  </Form.Item>
)

PmsSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

PmsSelector.defaultProps = {
  value: null,
}

export default PmsSelector



// WEBPACK FOOTER //
// ./src/AddPractice/Products/PmsSelector.js